export default function accountFakeApi(server, apiPrefixMock) {
    server.get(`${apiPrefixMock}/account/setting`, (schema) => {
        return schema.db.settingData[0]
    })

    server.get(`${apiPrefixMock}/account/setting/integration`, (schema) => {
        return schema.db.settingIntergrationData[0]
    })

    server.get(`${apiPrefixMock}/account/setting/billing`, (schema) => {
        return schema.db.settingBillingData[0]
    })

    server.get(`${apiPrefixMock}/account/invoice`, (schema, { queryParams }) => {
        const { id } = queryParams
        const invoice = schema.db.invoiceData
        invoice[0].id = id
        return invoice[0]
    })

    server.post(`${apiPrefixMock}/account/log`, (schema, { requestBody }) => {
        const { filter, activityIndex } = JSON.parse(requestBody)
        let loadable = true
        const maxGetItem = 3
        const count = (activityIndex - 1) * maxGetItem
        let logs = schema.db.logData
        if (count >= logs.length) {
            loadable = false
        }
        logs = logs.slice(count, activityIndex * maxGetItem)
        logs = logs.map((log) => {
            log.events = log.events.filter((event) =>
                filter.includes(event.type)
            )
            return log
        })
        const response = {
            data: logs,
            loadable,
        }
        return response
    })

    server.get(`${apiPrefixMock}/account/form`, (schema) => {
        return schema.db.accountFormData[0]
    })
}
